import { brand, cardBase, text } from '@/styles/shared';

export const audioCardStyles = {
  container: {
    ...cardBase,
    padding: '28px',
    marginBottom: '0px',
    textAlign: 'center',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
  },
  errorContainer: {
    color: 'red',
    fontSize: '12px',
    textAlign: 'center',
    maxWidth: '90%',
    mx: 'auto',
  },
  iconContainer: {
    width: '20px',
    height: '20px',
    margin: '0 auto 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: brand.purpleAccent,
    marginBottom: '8px',
    fontFamily: 'Montserrat',
  },
  subtitle: {
    ...text.body14Muted,
    marginBottom: '24px',
    textAlign: 'center',
  },
  playButton: {
    display: 'inline-flex',
    margin: 'auto',
    cursor: 'pointer',
  },
  micErrorContainer: {
    position: 'absolute',
    top: '40px',
    left: '0',
    width: '100%',
    zIndex: 100,
  },
  micErrorText: {
    color: 'red',
    fontSize: {
      xs: '12px', // Mobile: 12px
      md: '14px', // Tablet/Desktop: 14px
    },
    textAlign: 'center',
    backgroundColor: 'white',
    minHeight: 55,
    padding: {
      xs: '8px 12px',
      md: '10px 16px',
    },
    borderRadius: '6px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  },
};
